import { FC } from "react";
import Image from "next/image";
import classNames from "classnames";

import styles from "./CardSkeleton.module.scss";

interface CardSkeletonProps {
  index: number;
  variant?: "primary" | "secondary";
  className?: string;
}

const CardSkeleton: FC<CardSkeletonProps> = ({
  index,
  variant = "primary",
  className,
}) => {
  return (
    <div
      className={classNames(
        styles.card_skeleton,
        styles[variant],
        className,
        "animate-pulse"
      )}
    >
      <div className={styles.image}>
        <Image src="/images/card_default.png" alt="" fill priority />
      </div>

      <div className={styles.card_info}>
        <h3 className={styles.line}></h3>
        <h3 className={styles.line_2}></h3>
        <p className={styles.time}></p>
      </div>
    </div>
  );
};

export default CardSkeleton;
